<app-app-container>
  <app-header [category]="category()" />

  @switch (projectInfoState().status) {
    @case ('loading') {
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
        <div class="lg:col-span-2">
          <app-loading-skeleton variant="card" />
        </div>
        <div class="lg:col-span-1">
          <app-loading-skeleton variant="card" />
        </div>
      </div>
    }
    @case ('error') {
      <app-error-state
        class="mb-4 block"
        title="Failed to load project information"
        [message]="projectInfoError()!"
        (retry)="retryProjectInfo()" />
    }
    @case ('success') {
      <app-project-info [projectInfo]="projectInfoData()!" />
    }
  }

  @if (hasAnyGraphsData()) {
    <app-graphs
      [dataState]="graphsState()"
      [selectedPeriod]="selectedPeriod()"
      (periodChange)="onPeriodChange($event)"
      (retry)="retryGraphs()" />
  }

  <app-solutions
    [dataState]="solutionsWithProductsState()"
    [selectedPeriod]="selectedPeriod()"
    (retry)="retrySolutions()" />

  <app-comparison [dataState]="solutionsState()" [selectedPeriod]="selectedPeriod()" (retry)="retrySolutions()" />

  <app-warning-message />
</app-app-container>
